var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-ajax-table-with-crud-actions',{attrs:{"id":_vm.id,"titles":_vm.titles,"props":_vm.props,"bus":_vm.bus,"actions":_vm.actions,"duplicate":"1","endpoint":_vm.endpoint,"endpoint-params":_vm.endpointParams}})
}
var staticRenderFns = []

export { render, staticRenderFns }